module.exports = __webpack_public_path__ + "static/media/022ty@2x.f1b9e71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/022ty@2x.png
// module id = 1673
// module chunks = 0 1